export enum FeedType {
  OddsChange = 'OddsChange',
  BetSettlement = 'BetSettlement',
  RollbackBetSettlement = 'RollbackBetSettlement',
  BetStop = 'BetStop',
  BetCancel = 'BetCancel',
  RollbackBetCancel = 'RollbackBetCancel',
  FixtureChange = 'FixtureChange',
  LiveScoreChange = 'LiveScoreChange',
}

export enum ProducerType {
  SYSTEM = 0,
  LIVEODDS = 1,
  PREODDS = 3,
}

// 배구나 도타2 같이 승패만 있는 경우 HOME 은 4, AWAY 는 5 이다.
export enum UnifiedWayFieldType {
  HOMETEAM = 1,
  DRAW = 2,
  AWAYTEAM = 3,
  HOME = 4,
  AWAY = 5,
}

export enum ResultType {
  Lost = 0,
  Won = 1,
}

export enum MarketStatusType {
  Active = 0,
  Suspended = 1,
  Deactivated = 2,
  Settled = 3,
  Cancelled = 4,
  HandedOver = 5,
}

// deprecated
export enum EventStatusType {
  NotStarted = 0,
  Live = 1,
  Ended = 3,
  Closed = 4,
}

export enum EventStatusNameType {
  NotStarted = 'not_started',
  Live = 'live',
  Ended = 'ended',
  Closed = 'closed',
}


export enum SCORE_TYPE {
  // regular_period, overtime, penalties
  REGULAR = 'regular_period',
  OVERTIME = 'overtime',
  PENALTIES = 'penalties',
}

export enum MARKET_RESULT {
  BALANCED = 'Balanced',
  CANCELLED = 'Cancelled',
  PROCESSING = 'Processing',
  MODIFYING = 'Modifying', // 어드민에서 수동으로 마감, 롤백, 취소 실행시. 마감서버에서 마감 후 결과에 맞춰 수정됨.
}

export interface TimelineEvent {
  id: number
  type: string
  time?: Date
  name?: string
}
export interface TimelineMatchStarted extends TimelineEvent {}
export interface TimelinePeriodStart extends TimelineEvent {
  period?: number
  periodName?: string
}
export interface TimelineScoreChange extends TimelineEvent {
  matchTime?: number
  matchClock?: string
  team?: string
  homeScore?: number
  awayScore?: number
}
export interface TimelinePeriodScore extends TimelineEvent {
  period?: number
  homeScore?: number
  awayScore?: number
}
export interface TimelineBreakStart extends TimelineEvent {
  periodName?: string
  matchStatus?: number
}

export interface TimelineMatchEnded extends TimelineEvent {
  matchClock?: string
}

export interface TimelinePlayer {
  player: TimelineEvent
}

export interface TimelineGoalScorer extends TimelinePlayer{
  goalScorer: TimelineEvent
}

export interface TimelineAssist extends TimelinePlayer {
  assist: TimelineEvent[]
}

export interface TimelineEventAll extends TimelineMatchStarted,
  TimelinePeriodStart,
  TimelineScoreChange,
  TimelinePeriodScore,
  TimelineBreakStart,
  TimelineMatchEnded,
  TimelinePlayer,
  TimelineGoalScorer,
  TimelineAssist {}
